import List from "@/components/list";
import vue from "@/main.js";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  const parent = args.parent;
  const AccountTableConfig = [
    {
      label: "接收人姓名",
      prop: "toUserName"
    },
    {
      label: "手机号码",
      prop: "toMobile"
    },
    {
      label: "所属单位",
      prop: "deptName"
    },
    {
      label: "单位及职务",
      prop: "unitPosition"
    },
    {
      label: "最后发送时间",
      prop: "smsSendDate"
    },
    {
      label: "回复数量",
      render: vo => (
        <el-button
          size="small"
          type="text"
          onClick={() => {
            vue.$emit(
              "showDetail",
              parent.$route.query.mqTemplateId,
              vo.row.toMobile
            );
          }}
        >
          {vo.row.replyCount}
        </el-button>
      )
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
